import React, { useState } from 'react';
import { Col, Container, Row, } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ProceduresOne from './components/ProceduresOne';
import ProceduresTwo from './components/ProceduresTwo';


const NuclearProcedures = () => {

    const [procedure, setProcedure] = useState('1');

    const handlerProcedure = (proc) =>{
        setProcedure(proc);
    }

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 style={{ marginBottom: 30 }}>Procedimientos</h3>
                </Col>
            </Row>             
            <Row>
            <div style={{ marginBottom: 2 }}>
                <FormControl      >
                    <InputLabel id="contract-type-select-label">Procedimiento</InputLabel>
                    <Select
                        labelId="contract-type-select-label"
                        id="id-simple-select"
                        defaultValue={'1'}                        
                        onChange={(event) => {
                            //this.handlerBloodType(event.target.value);
                            handlerProcedure(event.target.value);
                        }}
                    //error={this.state.errors.hasOwnProperty("contractType") ? this.state.errors.tipoCont !== "" : false}
                    >
                        <MenuItem key={0} value={'1'}>Procedimiento Nuclear</MenuItem>
                        <MenuItem key={1} value={'2'}>Procedimiento Laboratorio</MenuItem>                        

                    </Select>

                </FormControl>
                </div>
            </Row>
            <Row>
                {procedure === '1' ?
                <ProceduresOne />
                :<ProceduresTwo/>}

            </Row>
        </Container>
    );

}

export default NuclearProcedures;